import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ApiCaller } from '@frontend/api'
import { adjustColorLuminance } from '@utils/frontend'

import { useChatContext } from '../../ChatProvider'

interface FollowUpBubbleProps {
	readonly text: string;
	readonly style?: 'primary' | 'light' | undefined;
	readonly disabled?: boolean | undefined;
	readonly onClick?: (() => void) | undefined;
}

export default function FollowUpBubble({ text, style = 'primary', disabled = false, onClick }: FollowUpBubbleProps) {
	const { color } = useChatContext()

	const stylesClasses = {
		primary: 'bg-blue-100 text-primary hover:bg-blue-200 active:bg-blue-50 text-left',
		light: 'bg-slate-100 hover:bg-slate-200 border border-blue-100 text-blue-400'
	}

	const styleClassName = stylesClasses[style]

	function handleClick() {
		if (onClick && !disabled) {
			ApiCaller.track('Followup_question_clicked')
			onClick()
		}
	}

	const customStyle = color ? adjustColorLuminance(color) : {}

	return (
		<button
			className={ ' w-full items-center flex min-h-[26px] rounded-xl px-3 py-1 m-1 text-xs transition-all duration-250 ease-in-out hover:opacity-70 '
				+ styleClassName
				+ (disabled ? ' opacity-50 cursor-not-allowed' : '') }
			style={ customStyle }
			onClick={ handleClick }
		>
			<FontAwesomeIcon icon="comment-dots" className="mr-2 w-3 h-3 shrink-0" />
			{ text }
		</button>
	)
}
